import { Div, state } from '@codesuma/baseline'
import style from './index.module.css'

// Says the store has a newer version (services/app-update decides when).
// Emits 'update' and 'later'; app.ts hands both to that service.

const button = (label: string, className: string) => {
    const b = Div(label)
    b.addClass(style.button, className)
    b.el.setAttribute('role', 'button')
    b.el.setAttribute('tabindex', '0')
    b.el.setAttribute('data-ripple', '')
    return b
}

export const UpdateNotice = () => {
    const base = Div()
    base.addClass(style.base)
    base.el.hidden = true

    const text = Div('نسخهٔ جدید آمده است.')
    text.addClass(style.text)

    const later = button('بعداً', style.later)
    later.el.addEventListener('click', () => base.emit('later'))
    const update = button('به‌روزرسانی', style.update)
    update.el.addEventListener('click', () => base.emit('update'))

    base.append(text, later, update)

    state.on('app-update', (on: boolean) => { base.el.hidden = !on })

    return base
}
